<div
  class="bg-white px-5 py-4 shadow-(--shadow-input) rounded-2xl mb-4 transition focus-within:ring-1 focus-within:ring-blue-500"
>
  <label class="block font-medium text-base text-(--text-secondary) mb-1 leading-6">
    {{ label | translate }}
  </label>

  <textarea
    #textareaEl
    [placeholder]="placeholder | translate"
    [formControl]="control!"
    class="w-full bg-transparent outline-none resize-none overflow-hidden text-(--text-primary) text-base font-semibold leading-6 placeholder:text-(--text-placeholder) mb-1"
    [rows]="row"
    (input)="onInput()"
  ></textarea>

  <div
    class="text-sm font-medium leading-5 text-right"
    [ngClass]="{
      'text-(--text-muted)': !textLimitExceed,
      'text-(--color-error)': textLimitExceed
    }"
  >
    {{ currentLength }}/{{ maxLength }}
  </div>
</div>
